var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-w-md mx-auto px-2 py-4"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }